import React from "react";
import DashboardView from "./DashboardView";

// En ebox no se reutiliza el Inicio de facturacion: el inicio del modulo es el Dashboard.
const HomeView = () => <DashboardView />;

export default HomeView;
